import { useState, useEffect } from 'react';

interface ExitIntentPopupProps {
  onClose: () => void;
}

const ExitIntentPopup = ({ onClose }: ExitIntentPopupProps) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('source', 'exit-intent-popup');

      const response = await fetch('https://readdy.ai/api/form/d5iefkpia7n1eqcquvp0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 overflow-hidden animate-scale-up">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full text-gray-600 transition-colors cursor-pointer z-10"
        >
          <i className="ri-close-line text-xl"></i>
        </button>

        {/* Content */}
        <div className="p-8">
          <div className="text-center mb-6">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-red-500 to-orange-500 rounded-full mx-auto mb-4">
              <i className="ri-gift-line text-4xl text-white"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">
              Wait! Don't Miss Out! 🎁
            </h2>
            <p className="text-lg text-gray-600">
              Get an exclusive <strong className="text-primary">15% OFF</strong> your first purchase!
            </p>
          </div>

          {submitStatus === 'success' ? (
            <div className="text-center py-8">
              <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                <i className="ri-check-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Success! Check Your Email 📧
              </h3>
              <p className="text-gray-600">
                Your 15% discount code is on its way!
              </p>
            </div>
          ) : (
            <>
              <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form id="exit-offer-form">
                <div>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-3 bg-gradient-to-r from-primary to-accent-green text-white font-semibold rounded-lg hover:shadow-xl transition-all disabled:opacity-50 cursor-pointer whitespace-nowrap"
                >
                  {isSubmitting ? 'Sending...' : 'Get My 15% OFF Code'}
                </button>

                {submitStatus === 'error' && (
                  <p className="text-red-600 text-sm text-center">
                    Something went wrong. Please try again.
                  </p>
                )}
              </form>

              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-3 text-sm text-gray-600">
                  <i className="ri-check-line text-green-600"></i>
                  <span>Exclusive deals & early access</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-600">
                  <i className="ri-check-line text-green-600"></i>
                  <span>Free shipping on orders over $50</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-600">
                  <i className="ri-check-line text-green-600"></i>
                  <span>Unsubscribe anytime</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExitIntentPopup;
